import { FC } from 'react';
import { Button, SvgIconTypeMap, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { alpha } from '@mui/material/styles';

interface CustomButtonProps {
  color: string;
  name: string;
  backgroundColor?: string;
  borderColor?: string;
  onClick: () => void;
  disabled?: boolean;
  startIcon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  endIcon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  height?: string;
  width?: string;
  minWidth?: string;
  borderRadius?: string;
  padding?: string;
}

const CustomButton: FC<CustomButtonProps> = (props) => {
  const resolvedBackgroundColor =
    props.disabled && props.backgroundColor
      ? alpha(props.backgroundColor, 0.35)
      : props.backgroundColor;

  const resolvedBorderColor = props.borderColor
    ? props.disabled
      ? alpha(props.borderColor, 0.75)
      : props.borderColor
    : 'transparent';

  const resolvedTextColor = props.disabled && props.color ? alpha(props.color, 0.75) : props.color;

  return (
    <Button
      onClick={props.onClick}
      sx={{
        backgroundColor: resolvedBackgroundColor,
        borderRadius: props.borderRadius ?? '2rem',
        padding: props.padding ?? '0.625rem 1.5rem',
        alignItems: 'center',
        textTransform: 'none',
        border: `1px solid ${resolvedBorderColor}`,
        '&:hover': {
          backgroundColor: resolvedBackgroundColor,
        },
        height: props.height,
        width: props.width,
        minWidth: props.minWidth,
        display: 'flex',
        gap: '0.2rem',
      }}
      disabled={props.disabled}
    >
      {props.startIcon && <props.startIcon sx={{ color: resolvedTextColor, height: '1rem' }} />}
      <Typography fontSize={'0.875rem'} fontWeight={500} sx={{ color: resolvedTextColor }}>
        {props.name}
      </Typography>
      {props.endIcon && <props.endIcon sx={{ color: resolvedTextColor, height: '1rem' }} />}
    </Button>
  );
};

export default CustomButton;
